import React from 'react';
import { Link } from 'react-router-dom';
import { Inbox, Archive as ArchiveIcon, Info, Palette, Mountain } from 'lucide-react';

export const Archive: React.FC = () => {
  const archivedItems = [
    {
      title: 'Simple Home Page (Elevation)',
      description: 'The minimal home page with just the Elevation title that was archived.',
      to: '/elevation/archive/home-simple',
      icon: Mountain,
      badge: 'Page',
    },
    {
      title: 'Previous Home Page',
      description: 'The complete home page that was replaced with the new Elevation design.',
      to: '/elevation/archive/home',
      icon: Mountain,
      badge: 'Page',
    },
    {
      title: 'Overview (Previous Home Page)',
      description: 'The prior overview page has been archived while we rebuild.',
      to: '/elevation/archive/overview',
      icon: Inbox,
      badge: 'Page',
    },
    {
      title: 'Detailed Information',
      description: 'Detailed information about the system and its capabilities.',
      to: '/elevation/archive/information',
      icon: Info,
      badge: 'Page',
    },
    {
      title: 'Design System Home Page Archive',
      description: 'Archived content from the original design system home page including brand color palettes and detailed design system components.',
      to: '/elevation/archive/design-system',
      icon: Palette,
      badge: 'Archive',
    },
    {
      title: 'Legacy design pages',
      description: 'Everything deprecated from the design language: earlier brand and design system pages, topic pages, product notes, the legacy palette and logo, and the pre-v3 diagram pages.',
      to: '/elevation/archive/design-language-legacy',
      icon: Palette,
      badge: 'Deprecated',
    },
    {
      title: 'Mission Control (Previous Home Page)',
      description: 'The previous home page design with journey selection, team activity, and learning pathways.',
      to: '/elevation/archive/mission-control',
      icon: Mountain,
      badge: 'Page',
    },
    // Add more archived items here as needed
  ];

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="text-center space-y-3 pt-8 pb-6">
        <div className="flex items-center justify-center space-x-3">
          <ArchiveIcon className="h-10 w-10 text-charcoal-600" />
          <h1 className="text-3xl font-bold text-charcoal-900">Archive</h1>
        </div>
        <p className="text-charcoal-600 text-sm">Older or deprecated items retained for reference. Click a tile to view details.</p>
      </div>

      {/* Archive Tiles */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {archivedItems.map((item, idx) => {
          const Icon = item.icon;
          return (
            <Link
              key={idx}
              to={item.to}
              className="group block p-6 border-2 border-charcoal-200 hover:border-charcoal-300 bg-[var(--bg-raised)] hover:shadow-md transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="p-3 bg-charcoal-50 border border-charcoal-200">
                  <Icon className="h-6 w-6 text-charcoal-600" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-lg font-semibold text-charcoal-900 group-hover:underline">{item.title}</h3>
                    <span className="px-2 py-0.5 text-xs rounded-full bg-[var(--mustard-dim)] text-[var(--mustard)]">{item.badge}</span>
                  </div>
                  <p className="text-sm text-charcoal-600">{item.description}</p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};


